import { consentPage, corporatePage, advocateConsent } from './common/utils';

import 'modules/advocate-nav';
import 'modules/challenges-carousel';
import 'modules/delete-members';
import 'modules/badges-progress';
import 'modules/level-form';

document.getElementById('infl-fe-contact-admin') && import('modules/contact-admin');

// document.getElementById('infl-fe-activity-feed') && import('modules/activity-feed');

if (!consentPage()) {
  if (corporatePage()) {
    import('modules/targeting-editor');
    import('modules/mountain-dew/challenge-card-preview');
    document.getElementById('infl-fe-admin-nav') && import('modules/admin-nav');
    document.getElementById('infl-fe-advocate-consent-settings') && import('modules/advocate-consent-settings');
    document.getElementById('infl-fe-advocate-table') && import('modules/advocate-table');
    document.getElementById('infl-fe-campaigns') && import('modules/campaigns');
    document.getElementById('infl-fe-hub-switcher') && import('modules/hub-switcher');
    document.getElementById('infl-fe-message-settings') && import('modules/message-settings');
    document.getElementById('infl-fe-multilingual') && import('modules/multilingual');
    document.getElementById('infl-fe-roi-settings') && import('modules/roi-settings');
    document.getElementById('infl-fe-roi-table') && import('modules/roi-view');
    document.getElementById('infl-fe-streaker-settings') && import('modules/streaker-settings');
    document.getElementById('infl-fe-advocacy-picker') && import('modules/advocacy-picker');
    document.getElementById('infl-fe-admin-question-challenge') && import('modules/admin-question-challenge');
    document.getElementById('infl-fe-digest-email-settings') && import('modules/digest-email-settings');
    document.getElementById('infl-fe-inactive-email-settings') && import('modules/inactive-email-settings');
    document.getElementById('infl-fe-hub-dashboards') && import('modules/hub-dashboards');
    document.getElementById('infl-fe-hub-reports') && import('modules/hub-reports');
  } else {
    import('modules/mountain-dew');
    import('modules/leaderboard');
    import('modules/achievements-tile');
    document.getElementById('infl-fe-advocate-notifications') && import('modules/advocate-notifications');
    document.getElementById('infl-fe-challenge-player-loader') && import('modules/challenge-player-loader');
    document.getElementById('infl-fe-streaker-challenge-page') && import('modules/streaker-challenge-page');
    document.getElementById('infl-fe-profile') && import('modules/profile');
    (document.getElementById('infl-fe-streaker-mobile')
      || document.getElementById('infl-fe-streaker-desktop')) && import('modules/streaker');
  }
}

if (advocateConsent()) {
  import('modules/mountain-dew/advocate-consent');
}
